// extracted by mini-css-extract-plugin
module.exports = {"container":"StreamsSummary-module__container__1-mPB","streamDataContainer":"StreamsSummary-module__streamDataContainer__1Cc55"};